/**
 * section-testimonials.js
 * Initializes Splide carousels for all testimonials sections on the page.
 * Depends on: splide.min.js (loaded before this script via defer ordering)
 */

(function () {
  // Guard: run initialization only once even if multiple section instances
  // cause this script tag to appear more than once in the DOM.
  if (window.__testimonialsInitialized) return;
  window.__testimonialsInitialized = true;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /**
   * Initialize a single testimonials section.
   * @param {HTMLElement} section - Element with [data-testimonials-section]
   */
  function initSection(section) {
    const splideEl = section.querySelector('.testimonials-splide');
    if (!splideEl || typeof Splide === 'undefined') return;

    // Avoid double-init (e.g. on theme editor section:load events)
    if (splideEl.dataset.splideInitialized === 'true') return;
    splideEl.dataset.splideInitialized = 'true';

    const interval = parseInt(section.dataset.speed || '4', 10) * 1000;

    const splide = new Splide(splideEl, {
      type: 'loop',
      autoplay: !prefersReducedMotion,
      interval,
      speed: prefersReducedMotion ? 0 : 900,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      pauseOnHover: true,
      pauseOnFocus: true,
      perPage: 3,
      perMove: 1,
      padding: { left: '40px', right: '40px' },
      gap: '24px',
      arrows: false,
      pagination: false,
      drag: true,
      dragMinThreshold: {
        mouse: 2,
        touch: 8,
      },
      waitForTransition: false,
      updateOnMove: true,
      breakpoints: {
        989: {
          perPage: 2,
          padding: { left: '30px', right: '30px' },
          gap: '20px',
        },
        749: {
          perPage: 1,
          padding: { left: '20px', right: '20px' },
          gap: '16px',
        },
      },
    });

    // Wire custom external navigation buttons
    const prevBtn = section.querySelector('[data-testimonials-prev]');
    const nextBtn = section.querySelector('[data-testimonials-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', () => splide.go('<'));
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => splide.go('>'));
    }

    splide.mount();
  }

  // Initialize all sections present at load time
  document.querySelectorAll('[data-testimonials-section]').forEach(initSection);

  // Support Shopify Theme Editor: re-initialize when a section is added or reloaded
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-testimonials-section]');
    if (section) {
      const splideEl = section.querySelector('.testimonials-splide');
      if (splideEl) splideEl.dataset.splideInitialized = '';
      initSection(section);
    }
  });
})();
